import moment, { Moment } from "moment";
import { Fragment, useState } from "react";
import { useAsync } from "react-async";
import { useHistory, useLocation } from "react-router-dom";
import { InvoiceDetailReportModel } from "../../api/models/invoiceDetailReport";
import { getInvoiceDetailReport } from "../../api/services/invoiceService";
import Layout from "../../components/layout";
import queryString from 'query-string';
import InvoiceDetailReportResponse from '../../api/responses/invoiceDetailReportResponse';
import InvoiceDetailReport from '../../components/invoiceDetailReport';


// Variables & general utility functions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const dateRangeFormat: string = 'MM/DD/YYYY';

const getMonthDateRange = (year: number, month: number) => {
    const startDate: Moment = moment([year, month - 1]);
    const endDate: Moment = moment(startDate).endOf('month');

    return { start: startDate, end: endDate };
}

const getServicePeriod = (year: number, month: number) => {
    const range = getMonthDateRange(year, month);
    return `${range.start.format(dateRangeFormat)} to ${range.end.format(dateRangeFormat)}`;
}

const initializeData = async ({ districtId, year, month, programId }: any) => {
    return await getInvoiceDetailReport(districtId, year, month, programId);
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// Main component
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
const InvoiceDetail = () => {

    // Variables / Constants
    //---------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    const parsedQueryString = queryString.parse(location.search);
    const districtId = Number(parsedQueryString.districtId);
    const programId = !parsedQueryString.programId ? null : Number(parsedQueryString.programId);
    const year = Number(parsedQueryString.year);
    const month = Number(parsedQueryString.month);
    const servicePeriod = getServicePeriod(year, month);
    //---------------------------------------------------------------------------------------------

    // States
    //---------------------------------------------------------------------------------------------
    const [report, setReport] = useState<InvoiceDetailReportModel>();
    //---------------------------------------------------------------------------------------------


    // API operations
    //---------------------------------------------------------------------------------------------
    const loadPageAsync = useAsync({
        promiseFn: initializeData,
        districtId: districtId,
        year: year,
        month: month,
        programId,
        onResolve: (response: InvoiceDetailReportResponse) => {
            if (response) {
                const reportData = response?.data.report;
                setReport(reportData);
            }
        },
    });
    //---------------------------------------------------------------------------------------------


    // In-component utility functions
    //---------------------------------------------------------------------------------------------
    const navigateToTimesheetWeek = (weekId: number): void => {
        history.push(`/proofing/week/${weekId}`);
    }
    //---------------------------------------------------------------------------------------------


    // UI layout
    //---------------------------------------------------------------------------------------------
    return (
        <Layout isLoading={loadPageAsync.isLoading}>
            <Fragment>
                <div className='px-4 py-3 mt-1 bg-white rounded-lg shadow main-page-body print:px-0'>
                    <InvoiceDetailReport
                        report={report}
                        servicePeriod={servicePeriod}
                        navigateToTimesheetWeek={navigateToTimesheetWeek}
                    />
                </div>
            </Fragment>
        </Layout>
    )
    //---------------------------------------------------------------------------------------------
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export default InvoiceDetail;
